export default __webpack_public_path__ + "static/media/img2.6dc011ff.jpg";